import i18n from "i18next";
import React, { useState, useEffect } from "react";

// Fluent UI Imports
import { ValidatePassword } from "../../../helpers/passwordValidator";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  Button,
  Field,
  Input,
  MessageBar,
  ProgressBar,
  Text,
} from "@fluentui/react-components";
import { WhiteboardFilled } from "@fluentui/react-icons";

interface IChangePasswordProps {
  userName: string;
  onDismiss: any;
  saveDisabled(item: boolean): void;
  newPassword(item: string): void;
  currentPassword(item: string): void;
  passwordChanged: string;
}

function ChangePassword(props: IChangePasswordProps) {
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [passwordStrength, setPasswordStrength] = useState(0);

  useEffect(() => {
    if (errorMessage != "") {
      props.saveDisabled(true);
    } else {
      props.saveDisabled(false);
    }
  }, [errorMessage]);
  useEffect(() => {
    setConfirmNewPassword("");
    setCurrentPassword("");
    setNewPassword("");
  }, [props.passwordChanged]);
  useEffect(() => {
    setSuccessMessage("");
    const result = ValidatePassword(newPassword);
    setPasswordStrength(result / 100);

    if (result < 100) {
      setErrorMessage(i18n.t<string>("pwdNotValid"));
    } else if (newPassword != confirmNewPassword) {
      setErrorMessage(i18n.t<string>("pwNotMatching"));
    } else {
      setErrorMessage("");
    }
  }, [newPassword, confirmNewPassword]);
  useEffect(() => {
    props.newPassword(newPassword);
  }, [newPassword]);
  useEffect(() => {
    props.currentPassword(currentPassword);
  }, [currentPassword]);
  const windowSize = useWindowSize();

  return (
    <div>
      <Field required label={i18n.t<string>("oldPassword")}>
        <Input
          type="password"
          placeholder={i18n.t<string>("oldPassword")}
          value={currentPassword}
          onChange={(ev, val) => setCurrentPassword(val.value ? val.value : "")}
        ></Input>
      </Field>
      <Field required label={i18n.t<string>("newPassword")}>
        <Input
          type="password"
          placeholder={i18n.t<string>("newPassword")}
          value={newPassword}
          onChange={(ev, val) => setNewPassword(val.value ? val.value : "")}
        ></Input>
      </Field>
      <Field
        required
        style={{ marginBottom: "5px" }}
        label={i18n.t<string>("confirmNewPassword")}
      >
        <Input
          type="password"
          placeholder={i18n.t<string>("confirmNewPassword")}
          value={confirmNewPassword}
          onChange={(ev, val) =>
            setConfirmNewPassword(val.value ? val.value : "")
          }
        ></Input>
      </Field>
      {passwordStrength > 0.0 && passwordStrength < 1.0 && (
        <>
          <ProgressBar
            style={{ marginTop: "7px", marginBottom: "7px", width: "300px" }}
            thickness="large"
            value={passwordStrength}
          />
          <Text>{Math.round(passwordStrength * 100)}%</Text>
        </>
      )}
      {errorMessage != "" && errorMessage != i18n.t<string>("pwdNotValid") && (
        <MessageBar intent={"error"}>{i18n.t<string>(errorMessage)}</MessageBar>
      )}
      {errorMessage == i18n.t<string>("pwdNotValid") && (
        <MessageBar intent={"warning"}>
          {i18n.t<string>(errorMessage)}
        </MessageBar>
      )}
      {successMessage != "" && (
        <MessageBar intent={"success"}>
          {i18n.t<string>(successMessage)}
        </MessageBar>
      )}
      {/* <div
        style={{
          width: "100%",
          marginTop: "5px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button
          icon={<WhiteboardFilled />}
          appearance="primary"
          disabled={errorMessage != ""}
          onClick={() => {
            changePassword();
          }}
        >
          {i18n.t<string>("changePassword")}
        </Button>
      </div> */}
    </div>
  );
}

export default ChangePassword;
